"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMuscleHeatmapDataForWorkoutsOrRoutines = exports.getMuscleHeatmapDataForExercises = exports.isMuscleHeatmapKey = void 0;
const typeUtils_1 = require("./typeUtils");
const _muscleHeatmapKeys = [
    'abdominals',
    'shoulders',
    'chest',
    'lower_back',
    'biceps',
    'triceps',
    'upper_back',
    'quadriceps',
    'calves',
    'lats',
    'hamstrings',
    'glutes',
    'abductors',
    'adductors',
    'traps',
    'forearms',
    'neck',
];
const isMuscleHeatmapKey = (x) => (0, typeUtils_1.isInArray)(x, _muscleHeatmapKeys);
exports.isMuscleHeatmapKey = isMuscleHeatmapKey;
/**
 * Calculates muscle group opacity from exercise data: primary muscle groups are 1.0, secondary are 0.5
 */
const getMuscleHeatmapDataForExercises = (exercises) => {
    var _a;
    // initialise all keys to 0
    const data = _muscleHeatmapKeys.reduce((prev, curr) => (Object.assign(Object.assign({}, prev), { [curr]: 0 })), {});
    for (const e of exercises) {
        if (!e)
            continue;
        if ((0, exports.isMuscleHeatmapKey)(e.muscle_group)) {
            data[e.muscle_group] = 1;
        }
        for (const m of e.other_muscles) {
            if ((0, exports.isMuscleHeatmapKey)(m)) {
                data[m] = Math.max((_a = data[m]) !== null && _a !== void 0 ? _a : 0, 0.5);
            }
        }
    }
    return data;
};
exports.getMuscleHeatmapDataForExercises = getMuscleHeatmapDataForExercises;
/**
 *
 * @param workoutsOrRoutines An array of objects with an array of exercises
 * @param getExerciseTemplateWithId A function that returns an ExerciseTemplate (or undefined) given an ID
 * @returns MuscleHeatmapData with a value that represents how much a muscle group was used in the workouts or routines:
 * A primary muscle counts as 1.0 per workout/routine, and a secondary muscle counts as 0.5 per workout/routine
 */
const getMuscleHeatmapDataForWorkoutsOrRoutines = ({ workoutsOrRoutines, }) => {
    // initialise all keys to 0
    const data = _muscleHeatmapKeys.reduce((prev, curr) => (Object.assign(Object.assign({}, prev), { [curr]: 0 })), {});
    workoutsOrRoutines.forEach((workoutOrRoutine) => {
        const muscleData = (0, exports.getMuscleHeatmapDataForExercises)(workoutOrRoutine.exercises);
        Object.keys(muscleData).forEach((muscle) => {
            data[muscle] =
                (data[muscle] || 0) +
                    (muscleData[muscle] || 0);
        });
    });
    return data;
};
exports.getMuscleHeatmapDataForWorkoutsOrRoutines = getMuscleHeatmapDataForWorkoutsOrRoutines;
